<template>
	<div @click="modal__handleClick">

		<slot/>

	</div>
</template>

<script>

export default {

	name: 'video-embed',

	props: {
		url : {
			default: '',
			type: String,
		}
	},

	methods: {
		modal__handleClick( event ) {
			this.$modal.show({
				template: `
				<div class="VideoModal">
					<video controls controlsList="nodownload" autoplay>
					  <source :src="url" type="video/mp4">
					Your browser does not support the video tag.
					</video>
				</div>`,
				props: ['url']},
				{
					url: this.url,
				},
				{
					classes: 'isVideoPlayer',
					adaptive: true,
					scrollable: true,
					width: 900,
					height: 'auto'
				})
			event.preventDefault()
		},
	}

}
</script>
